import React, { ReactNode } from "react";
import cx from "classnames";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";

import { Heading } from "components/ui/Heading";
import { Button } from "components/ui/Button";
import GlassOne from "svg/glass-products-1.inline.svg";
import GlassTwo from "svg/glass-products-2.inline.svg";
import GlassThree from "svg/glass-products-3.inline.svg";

import * as s from "./ProductCard.module.sass";

export type IProduct = {
  name: string;
  description: string;
  links: {
    label: string;
    href: string;
  }[];
  mainImage: ImageDataLike;
  mainLink: {
    label: ReactNode;
    labelMobile?: ReactNode;
    href: string;
  };
};

type ProductCardProps = {
  product: IProduct;
  glassType: 0 | 1 | 2;
};

export const ProductCard: FC<ProductCardProps> = ({
  product: { name, description, links, mainImage, mainLink },
  glassType = 0,
  className,
}) => {
  const image = getImage(mainImage)!;

  return (
    <div className={cx(s.root, className)}>
      {glassType === 0 && (
        <GlassOne className={cx(s.illustration, s.illustrationOne)} />
      )}
      {glassType === 1 && (
        <GlassTwo className={cx(s.illustration, s.illustrationTwo)} />
      )}
      {glassType === 2 && (
        <GlassThree className={cx(s.illustration, s.illustrationThree)} />
      )}
      {/*<Illustration className={s.illustration} />*/}
      <Heading type="h5" as="h3" className={s.header}>
        {name}
      </Heading>
      <p>{description}</p>
      <div className={s.links}>
        {links.map(({ label, href }) => (
          <Button key={href} theme="tertiary" href={href} className={s.link}>
            {label}
          </Button>
        ))}
      </div>
      <div className={s.imageWrapper}>
        <GatsbyImage image={image} alt={name} className={s.image} />
      </div>
      <Button to={mainLink.href} className={s.button}>
        <span className={s.mobile}>
          {mainLink.labelMobile ?? mainLink.label}
        </span>
        <span className={s.desktop}>{mainLink.label}</span>
      </Button>
    </div>
  );
};
